import * as React from 'react';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';

import utils = egr.wcf.utils;
import { UIHelper } from '../../utils/UIHelper';

export interface BaseDialogButton {
    label: string;
    callback: () => void;
    green?: boolean;
}

export interface BaseDialogProps extends React.Props<BaseDialog> {
    buttons: Array<BaseDialogButton>;
    label?: string;
    closeCallback?: () => void;
}

export class BaseDialog extends React.Component<BaseDialogProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="dialog-page" onClick={this.close}>
                <div
                    className={'dialog-page-resizer' + (AppConfigurationStore.softKeyboard() ? ' dialog-page-resizer-softkeyboard' : '')}
                    onClick={UIHelper.stopEvent}
                >
                    {this.header()}
                    {this.buttons()}
                </div>
            </div>
        );
    }

    protected close = (): void => {
        ViewSettingsActions.closeMessage();
        if (this.props.closeCallback != null) {
            this.props.closeCallback();
        }
    };

    protected buttons = (): JSX.Element | null => {
        if (this.props.buttons.length === 0) {
            return null;
        }
        let classNameForDirection: string = 'dialog-page-buttons-horizontal';
        if (this.props.buttons.length > 2) {
            classNameForDirection = 'dialog-page-buttons-vertical';
        }
        return (
            <div className={classNameForDirection}>
                {this.props.buttons.map((buttonConfig: BaseDialogButton, index: number): JSX.Element => {
                    return (
                        <div
                            className={'dialog-page-button' + (buttonConfig.green ? ' dialog-page-button-green' : '')}
                            onClick={() => {
                                ViewSettingsActions.closeMessage();
                                buttonConfig.callback();
                            }}
                            key={index}
                        >
                            <span>{buttonConfig.label}</span>
                        </div>
                    );
                })}
            </div>
        );
    };

    protected header = (): JSX.Element | null => {
        if (utils.string.isNullOrEmpty(this.props.label)) {
            return null;
        }
        return (
            <div className="dialog-page-header">{this.props.label}</div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dialog/BaseDialog.tsx